// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.smses .card-with-chat-list .chat-list-main {
  display: flex;
  gap: 0px 7px;
  margin-bottom: 3px;
}
.smses .card-with-chat-list .chat-scrollable-div {
  overflow-y: auto;
  overflow-x: hidden;
  border: 1px solid rgba(140, 140, 140, 0.35);
}
.smses .card-with-chat-list .chat-scrollable-div .infinite-scroll-component {
  overflow: hidden !important;
}
.smses .card-with-chat-list .chat-scrollable-div .infinite-scroll-item {
  padding: 0;
  border-radius: 10px;
}
.smses .card-with-chat-list .chat-scrollable-div .infinite-scroll-item .chat-list-item {
  cursor: pointer;
}
.smses .card-with-chat-list .chat-scrollable-div .infinite-scroll-item .ant-badge {
  width: 100%;
}
.smses .card-with-chat-list .chat-scrollable-div .infinite-scroll-item .ant-badge .inside-badge-chat-item {
  cursor: pointer;
  padding: 10px;
  width: 100%;
}
.smses .card-with-chat-list .chat-scrollable-div .infinite-scroll-item .ant-badge .inside-badge-chat-item .message-title {
  white-space: break-spaces;
  word-break: break-all;
  margin: 0 !important;
}
.smses .card-with-chat-list .chat-scrollable-div .infinite-scroll-item .ant-badge .inside-badge-chat-item .chat-item-footer-row {
  flex-flow: nowrap !important;
}
.smses .card-with-chat-list .chat-scrollable-div .infinite-scroll-item .ant-badge .inside-badge-chat-item .chat-item-footer-row .infinite-scroll-item-date {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.smses .card-with-chat-list .chat-scrollable-div .infinite-scroll-item .ant-badge .inside-badge-chat-item .chat-item-footer-row .infinite-scroll-item-date:hover {
  overflow: visible;
}
.smses .card-with-chat-list .create-new-chat-button,
.smses .card-with-chat-list .create-new-chat-select {
  width: 100%;
  margin-bottom: 10px;
}
.smses .card-with-chat-list .create-new-chat-button .ant-select,
.smses .card-with-chat-list .create-new-chat-select .ant-select {
  width: 100%;
}
.smses .card-with-chat-list .chat-filter {
  margin-bottom: 3px;
}
.smses .card-with-chat-list .chat-filter .ant-radio-button-wrapper {
  margin-left: 10px;
}
.smses .card-with-chat-list .chat-filter .ant-radio-button-wrapper:first-child {
  margin-left: 0;
}
.link-to-insured-modal .ant-select {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/components/smses/sms-messages/chat-list/styles.less"],"names":[],"mappings":"AAAA;EAGM,aAAA;EACA,YAAA;EACA,kBAAA;AADN;AAJA;EASM,gBAAA;EACA,kBAAA;EACA,2CAAA;AAFN;AATA;EAcQ,2BAAA;AAFR;AAZA;EAkBQ,UAAA;EACA,mBAAA;AAHR;AAhBA;EAsBU,eAAA;AAHV;AAnBA;EA0BU,WAAA;AAJV;AAtBA;EA6BY,eAAA;EACA,aAAA;EACA,WAAA;AAJZ;AA3BA;EAkCc,yBAAA;EACA,qBAAA;EACA,oBAAA;AAJd;AAhCA;EAwCc,4BAAA;AALd;AAnCA;EA2CgB,mBAAA;EACA,gBAAA;EACA,uBAAA;AALhB;AAxCA;EAiDgB,iBAAA;AANhB;AA3CA;;EA2DM,WAAA;EACA,mBAAA;AAZN;AAhDA;;EA+DQ,WAAA;AAXR;AApDA;EAoEM,kBAAA;AAbN;AAvDA;EAuEQ,iBAAA;AAbR;AA1DA;EA2EQ,cAAA;AAdR;AAoBA;EAEI,WAAA;AAnBJ","sourcesContent":[".smses {\n  .card-with-chat-list {\n    .chat-list-main {\n      display: flex;\n      gap: 0px 7px;\n      margin-bottom: 3px;\n    }\n\n    .chat-scrollable-div {\n      overflow-y: auto;\n      overflow-x: hidden;\n      border: 1px solid rgba(140, 140, 140, 0.35);\n\n      .infinite-scroll-component {\n        overflow: hidden !important;\n      }\n\n      .infinite-scroll-item {\n        padding: 0;\n        border-radius: 10px;\n\n        .chat-list-item {\n          cursor: pointer;\n        }\n\n        .ant-badge {\n          width: 100%;\n\n          .inside-badge-chat-item {\n            cursor: pointer;\n            padding: 10px;\n            width: 100%;\n\n            .message-title {\n              white-space: break-spaces;\n              word-break: break-all;\n              margin: 0 !important;\n            }\n\n            .chat-item-footer-row {\n              flex-flow: nowrap !important;\n\n              .infinite-scroll-item-date {\n                white-space: nowrap;\n                overflow: hidden;\n                text-overflow: ellipsis;\n              }\n\n              .infinite-scroll-item-date:hover {\n                overflow: visible;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .create-new-chat-button,\n    .create-new-chat-select {\n      width: 100%;\n      margin-bottom: 10px;\n\n      .ant-select {\n        width: 100%;\n      }\n    }\n\n    .chat-filter {\n      margin-bottom: 3px;\n\n      .ant-radio-button-wrapper {\n        margin-left: 10px;\n      }\n\n      .ant-radio-button-wrapper:first-child {\n        margin-left: 0;\n      }\n    }\n  }\n}\n\n.link-to-insured-modal {\n  .ant-select {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
